import KcAdminClient from "@keycloak/keycloak-admin-client";

const kcAdminClient = new KcAdminClient({
	baseUrl: import.meta.env.VITE_KEYCLOAK_AUTH_URL,
	realmName: import.meta.env.VITE_KEYCLOAK_REALM,
});

export default async function getKeyCloakAdminClient() {
	await kcAdminClient
		.auth({
			username: import.meta.env.VITE_KEYCLOAK_ADMIN_USER,
			password: import.meta.env.VITE_KEYCLOAK_ADMIN_PASSWORD,
			grantType: "password",
			clientId: "admin-cli",
		})
		.catch(console.log);

	return kcAdminClient;
}
